export default __webpack_public_path__ + "media/images/images/carousel/23-a89f9bacc09d33a25476e65eaf2351d1.jpg";